import React, { useEffect } from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {
  Notification,
    Pace
} from "components/Atoms";

import {Box, Container} from "@mui/material";
import PhotoUpload from "components/PhotoUpload";
import * as Actions         from "actions";

const AdminDisplayDeliveredMain = (props) => {

    const {
        serviceError, reqStatus,
        isLoading, selectedShop, images, cancelEdit,
        adminDisplayDeliveredClicked
    } = props;

    const {
        shop_id
    } = selectedShop;

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };


    useEffect(() => {
        if (serviceError && reqStatus) {
            let feedback = {
                title: "Something went wrong!",
                description: serviceError.statusText,
            };
            sendNotification("error", feedback);
        }
    }, [serviceError, reqStatus]);

    const addImageCallback = (file) => {
        const formData = new FormData()
        formData.append("image", file);
        adminDisplayDeliveredClicked(shop_id, formData);
    }



      return (
          <Container>
              {isLoading && <Pace color="#27ae60" height="2px" />}
              <Box >
                  <PhotoUpload
                            isRemoveAllowed={false}
                            images={images}
                            addImageCallback={addImageCallback}
                            cancelEdit={cancelEdit}
                  />
              </Box>
          </Container>
      );
};

// Mapping Props and State.
const adminDisplayDeliveredMain = connect(
    ({ adminShops, bootupInfo }) => ({
        bootupInfo: bootupInfo,
        reqStatus: adminShops.reqStatus,
        isLoading: adminShops.isLoading,
        serviceError: adminShops.serviceError,
        leadImageList: adminShops.leadImageList,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminDisplayDeliveredMain);

export { adminDisplayDeliveredMain as default };
